export default __webpack_public_path__ + "static/game-8fe8608ad554fd24f23d69fcde473e49.webp";